module.exports = __webpack_public_path__ + "static/media/baquelite.7f5f114d.jpeg";